import {Component, Input, OnInit} from '@angular/core';
import {LookUp} from '../../../services/api.client';
import {Observable} from 'rxjs';
import {UntypedFormControl} from '@angular/forms';
import {SecurityService} from '../../../services/SecurityService';

@Component({
    selector: 'efnZoneCheckbox',
    templateUrl: './EfnZoneCheckbox.html',
    standalone: false
})
export class EfnZoneCheckbox implements OnInit {
  efnZones: LookUp[];
  efnZones$: Observable<LookUp[]>;

  @Input()
  control: UntypedFormControl;

  constructor(private _securityService: SecurityService) {
    this.efnZones$ = this._securityService.zones$;
  }

  ngOnInit(): void {
    this.efnZones$.subscribe(efnZones => this.efnZones = efnZones);
  }
}
